import React from 'react';
import { useT } from '../i18n/LanguageContext';

const PrivacyPolicy = () => {
  const { lang } = useT();

  const content = {
    fr: {
      badge: 'GPE – ÉNERGIES & SERVICES',
      title: 'Politique de confidentialité',

      intro1: `
        Le site www.gpefrance.eu est exploité par GPE,
        responsable du traitement des données personnelles
        collectées via le site.
      `,

      intro2: `
        Cette politique explique quelles informations peuvent
        être collectées, pourquoi elles sont utilisées et
        comment elles sont protégées.
      `,

      sections: [
        {
          title: 'Les informations personnelles que nous collectons',
          paragraphs: [
            `
              Lors de la navigation, certaines informations techniques
              peuvent être collectées automatiquement, notamment
              les informations relatives au navigateur, à l'adresse IP,
              au fuseau horaire et aux cookies.
            `,
            `
              Les informations fournies volontairement par l'utilisateur
              peuvent également comprendre le nom, prénom, adresse,
              organisation, téléphone et adresse électronique,
              notamment lorsqu'un formulaire est utilisé.
            `,
          ],
        },
        {
          title: 'Pourquoi traitons-nous vos données ?',
          paragraphs: [
            `
              Les données sont utilisées uniquement lorsque cela est
              nécessaire au fonctionnement du site, à la fourniture
              des services demandés, à la communication avec les
              utilisateurs ou à des mesures statistiques.
            `,
          ],
        },
        {
          title: 'Vos droits',
          rights: [
            "Droit d'être informé",
            "Droit d'accès",
            'Droit de rectification',
            "Droit à l'effacement",
            'Droit de limitation du traitement',
            'Droit à la portabilité',
            "Droit d'opposition",
            'Droits relatifs au profilage et à la décision automatisée',
          ],
          paragraphs: [
            `
              Pour exercer vos droits, contactez GPE à :
            `,
          ],
        },
        {
          title: "Liens vers d'autres sites web",
          paragraphs: [
            `
              Le site peut contenir des liens vers des sites tiers.
              GPE n'est pas responsable de leurs politiques de
              confidentialité ou de leurs pratiques.
            `,
          ],
        },
        {
          title: "Sécurité de l'information",
          paragraphs: [
            `
              GPE met en place des mesures administratives,
              techniques et physiques destinées à protéger les
              données contre les accès, utilisations, modifications
              ou divulgations non autorisés.
            `,
          ],
        },
        {
          title: 'Divulgation légale',
          paragraphs: [
            `
              Certaines informations peuvent être communiquées
              lorsque la loi l'exige ou lorsque cela est nécessaire
              pour protéger les droits, la sécurité ou les intérêts
              légitimes de GPE ou de tiers.
            `,
          ],
        },
        {
          title: 'Informations de contact',
          paragraphs: [
            `
              Pour toute question concernant cette politique ou
              vos données personnelles :
            `,
          ],
        },
      ],
      email: 'contact@gpefrance.eu',
    },

    en: {
      badge: 'GPE – ENERGY & SERVICES',
      title: 'Privacy Policy',

      intro1: `
        The website www.gpefrance.eu is operated by GPE,
        which is responsible for processing personal data
        collected through the website.
      `,

      intro2: `
        This policy explains what information may be collected,
        why it is used and how it is protected.
      `,

      sections: [
        {
          title: 'Personal Information We Collect',
          paragraphs: [
            `
              During browsing, certain technical information may
              be collected automatically, including information
              relating to the browser, IP address, time zone
              and cookies.
            `,
            `
              Information voluntarily provided by users may also
              include their first name, last name, address,
              organisation, telephone number and email address,
              particularly when a form is submitted.
            `,
          ],
        },
        {
          title: 'Why Do We Process Your Data?',
          paragraphs: [
            `
              Data is used only when necessary for the operation
              of the website, the provision of requested services,
              communication with users or statistical purposes.
            `,
          ],
        },
        {
          title: 'Your Rights',
          rights: [
            'Right to be informed',
            'Right of access',
            'Right to rectification',
            'Right to erasure',
            'Right to restriction of processing',
            'Right to data portability',
            'Right to object',
            'Rights relating to profiling and automated decision-making',
          ],
          paragraphs: [
            `
              To exercise your rights, please contact GPE at:
            `,
          ],
        },
        {
          title: 'Links to Other Websites',
          paragraphs: [
            `
              The website may contain links to third-party websites.
              GPE is not responsible for their privacy policies
              or practices.
            `,
          ],
        },
        {
          title: 'Information Security',
          paragraphs: [
            `
              GPE implements administrative, technical and physical
              measures intended to protect data against unauthorised
              access, use, modification or disclosure.
            `,
          ],
        },
        {
          title: 'Legal Disclosure',
          paragraphs: [
            `
              Certain information may be disclosed when required
              by law or when necessary to protect the rights,
              security or legitimate interests of GPE or third parties.
            `,
          ],
        },
        {
          title: 'Contact Information',
          paragraphs: [
            `
              For any questions concerning this policy or
              your personal data:
            `,
          ],
        },
      ],
      email: 'contact@gpefrance.eu',
    },

    ar: {
      badge: 'GPE – الطاقة والخدمات',
      title: 'سياسة الخصوصية',

      intro1: `
        يتم تشغيل موقع www.gpefrance.eu من قبل GPE،
        وهي الجهة المسؤولة عن معالجة البيانات الشخصية
        التي يتم جمعها من خلال الموقع.
      `,

      intro2: `
        توضح هذه السياسة المعلومات التي قد يتم جمعها،
        وأسباب استخدامها وكيفية حمايتها.
      `,

      sections: [
        {
          title: 'المعلومات الشخصية التي نجمعها',
          paragraphs: [
            `
              أثناء تصفح الموقع، قد يتم جمع بعض المعلومات التقنية
              تلقائياً، بما في ذلك المعلومات المتعلقة بالمتصفح
              وعنوان IP والمنطقة الزمنية وملفات تعريف الارتباط.
            `,
            `
              وقد تشمل المعلومات التي يقدمها المستخدم طوعاً
              الاسم والعنوان والمنظمة ورقم الهاتف وعنوان البريد
              الإلكتروني، خصوصاً عند استخدام أحد النماذج.
            `,
          ],
        },
        {
          title: 'لماذا نعالج بياناتكم؟',
          paragraphs: [
            `
              يتم استخدام البيانات فقط عندما يكون ذلك ضرورياً
              لتشغيل الموقع، أو لتقديم الخدمات المطلوبة،
              أو للتواصل مع المستخدمين، أو لأغراض إحصائية.
            `,
          ],
        },
        {
          title: 'حقوقكم',
          rights: [
            'الحق في الحصول على المعلومات',
            'حق الوصول إلى البيانات',
            'حق التصحيح',
            'حق الحذف',
            'حق تقييد المعالجة',
            'حق نقل البيانات',
            'حق الاعتراض',
            'الحقوق المتعلقة بالتنميط واتخاذ القرارات الآلية',
          ],
          paragraphs: [
            `
              لممارسة حقوقكم، يرجى التواصل مع GPE عبر:
            `,
          ],
        },
        {
          title: 'روابط إلى مواقع إلكترونية أخرى',
          paragraphs: [
            `
              قد يحتوي الموقع على روابط إلى مواقع تابعة لأطراف
              ثالثة. ولا تتحمل GPE مسؤولية سياسات الخصوصية
              أو ممارسات تلك المواقع.
            `,
          ],
        },
        {
          title: 'أمن المعلومات',
          paragraphs: [
            `
              تطبق GPE إجراءات إدارية وتقنية ومادية تهدف إلى
              حماية البيانات من الوصول أو الاستخدام أو التعديل
              أو الإفصاح غير المصرح به.
            `,
          ],
        },
        {
          title: 'الإفصاح القانوني',
          paragraphs: [
            `
              قد يتم الإفصاح عن بعض المعلومات عندما يقتضي القانون
              ذلك أو عندما يكون ضرورياً لحماية حقوق أو أمن أو
              المصالح المشروعة لشركة GPE أو الأطراف الأخرى.
            `,
          ],
        },
        {
          title: 'معلومات الاتصال',
          paragraphs: [
            `
              لأي استفسار يتعلق بهذه السياسة أو بياناتكم الشخصية:
            `,
          ],
        },
      ],
      email: 'contact@gpefrance.eu',
    },
  };

  const c = content[lang] || content.fr;
  const isArabic = lang === 'ar';

  return (
    <main className="bg-white min-h-screen">

      <section className="bg-[#0b1c3a] text-white pt-40 pb-20">
        <div className="max-w-6xl mx-auto px-6">

          <span className="text-[#f5c518] text-sm font-bold tracking-[0.2em]">
            {c.badge}
          </span>

          <h1 className="text-4xl md:text-5xl font-bold mt-4">
            {c.title}
          </h1>

        </div>
      </section>

      <section
        className="max-w-5xl mx-auto px-6 py-16 text-slate-700"
        dir={isArabic ? 'rtl' : 'ltr'}
      >

        <div className="space-y-5 text-base leading-8">

          <p className="whitespace-pre-line">
            {c.intro1}
          </p>

          <p className="whitespace-pre-line">
            {c.intro2}
          </p>

        </div>

        {c.sections.map((section, index) => (
          <section
            key={index}
            className="mt-12"
          >

            <h2 className="text-2xl font-bold text-[#0b1c3a] mb-5">
              {section.title}
            </h2>

            {section.paragraphs?.map((paragraph, pIndex) => (
              <p
                key={pIndex}
                className="text-base leading-8 mb-4 whitespace-pre-line"
              >
                {paragraph}
              </p>
            ))}

            {section.rights && (
              <ul className="list-disc pl-6 space-y-2 mb-5">
                {section.rights.map((right, rIndex) => (
                  <li key={rIndex}>
                    {right}
                  </li>
                ))}
              </ul>
            )}

            {(section.title === 'Vos droits' ||
              section.title === 'Your Rights' ||
              section.title === 'حقوقكم') && (
              <p className="font-semibold mt-4">
                {c.email}
              </p>
            )}

            {(section.title === 'Informations de contact' ||
              section.title === 'Contact Information' ||
              section.title === 'معلومات الاتصال') && (
              <p className="font-semibold">
                {c.email}
              </p>
            )}

          </section>
        ))}

      </section>

    </main>
  );
};

export default PrivacyPolicy;